export interface IEpisodeRouteParams {
    patientId: string;
    episodeId?: string;
    disciplineId?: string;
}

export const buildDisciplineSearchParams = (disciplineId?: string): string => {
    const params = new URLSearchParams();
    if (disciplineId) {
        params.set('discipline', disciplineId);
    }
    return params.toString();
};

export const buildEpisodeSearchParams = (episodeId?: string): string => {
    const params = new URLSearchParams();
    if (episodeId) {
        params.set('episode', episodeId);
    }
    return params.toString();
};

export const buildEpisodeDisciplineLink = (
    { patientId, episodeId }: IEpisodeRouteParams,
    targetDisciplineId?: string,
) => {
    const base = `/patients/${patientId}/scheduling`;
    const params = new URLSearchParams();
    if (episodeId) {
        params.set('episode', episodeId);
    }
    if (targetDisciplineId) {
        params.set('discipline', targetDisciplineId);
    }
    return `${base}?${params.toString()}`;
};

export const buildEpisodeLink = ({ patientId, episodeId }: IEpisodeRouteParams) => {
    const base = `/patients/${patientId}/scheduling`;
    const params = new URLSearchParams();
    if (episodeId) {
        params.set('episode', episodeId);
    }
    return `${base}?${params.toString()}`;
};
